module.exports = new __parcel__URL__("bg_stars_box_03.9b504c8f.jpg").toString();